import { jsx as _jsx } from "react/jsx-runtime";
const SlideItem = ({ children }) => _jsx("li", { children: children });
export { SlideItem };
